import { Controller } from "@hotwired/stimulus"

// Copies a static text value to the clipboard and briefly swaps the button label.
// Usage:
//   %button{ type: "button",
//            data: { controller: "clipboard", action: "clipboard#copy",
//                    clipboard_text_value: "size: '|'\nprice: '|'\n" } }
export default class extends Controller {
  static values = {
    text: String,
    confirmText: { type: String, default: "Copied!" }
  }

  copy(event) {
    event.preventDefault()
    const button = event.currentTarget
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = button.innerHTML
      button.innerHTML = this.confirmTextValue
      setTimeout(() => { button.innerHTML = original }, 1500)
    })
  }
}
